export const ImageToCodeBlock = (bm, category, label, type) => {
  const style = `
  <style>
  [data-gjs-type=${type}]::after {
    content: "Image to UI Container"
  }
  </style>
`;
  bm.add(type, {
    label: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="32" height="50"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"/></svg>
          <div class="gjs-block-label">
          ${label}</div>`,
    category: category,
    activate: true,
    select: true,
    content: `
      <div class='${type} p-5 width100' style="width:100%" data-js="${type}" data-gjs-type="${type}">
      </div>
      ${style}`,
    render: ({ model, className }) => `
            <div class="${className}-label ${className}__drapcode-wrap">
            ${model.get('label')}
            </div>
      
            <span class="${className}__info no-doc">
              <a target="_blank" href="https://academy.drapcode.com/docs/app-pre-built-section/introduction-to-pre-built-section" draggable="false">
                <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${label}?"></i>
              </a>
            </span>
          `,
  });
};
export default (dc, label, type, config) => {
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { projectId, refs, commands, toolbarBtnAiComponentCode } = config;
  let timedInterval;
  dc.addType('script', {
    view: {
      onRender() {
        const isCC = this.model.closestType(refs.aiComponentRef);
        isCC && (this.el.innerHTML = '');
      },
    },
  });

  dc.addType(type, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          icon: '<i class="fa fa-magic"></i>',
          name: label,
          editable: true,
          projectId: projectId,
          // traits: [],
          script: function () {},
        },
        init() {
          this.listenTo(this, `change:${refs.imageToCodeCustomCode}`, this.onAiComponentCodeChange);
          const initialCode = this.get(refs.imageToCodeCustomCode);
          !this.components().length && this.components(initialCode);
          const toolbar = this.get('toolbar');
          const imageToCodeId = 'image-to-code';
          // Add the custom code toolbar button if requested and it's not already in
          if (
            toolbarBtnAiComponentCode &&
            !toolbar.filter((tlb) => tlb.id === imageToCodeId).length
          ) {
            toolbar.unshift({
              id: imageToCodeId,
              command: commands.image_to_code_custom_code,
              attributes: { class: 'fa fa-magic', title: 'Image to UI' },
              ...toolbarBtnAiComponentCode,
            });
          }
        },

        onAiComponentCodeChange() {
          this.components(this.get(refs.imageToCodeCustomCode));
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === type) {
            return {
              type: type,
            };
          }
        },
      },
    ),
    view: defaultType.view.extend({
      init() {
        this.listenTo(this.model.components(), 'add remove reset', this.onComponentsChange);
        this.onComponentsChange();
      },

      onComponentsChange() {
        timedInterval && clearInterval(timedInterval);
        timedInterval = setTimeout(() => {
          const { model } = this;
          const content = model.get(refs.imageToCodeCustomCode) || '';
          let droppable = 1;

          if (content.indexOf('<script') >= 0) {
            this.el.innerHTML = config.placeholderScript;
            droppable = 0;
          }

          model.set({ droppable });
        }, 0);
      },

      onActive() {
        const target = this.model;
        this.em.get('Commands').run(commands.image_to_code_custom_code, { target });
      },
    }),
  });
};
